import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, MapPinned, RefreshCw, TrendingUp } from 'lucide-react';

const riskFactors = [
  {
    icon: <ShieldCheck className="h-8 w-8" />,
    title: 'Diversified Asset Base',
    description: 'Spread across 20 machines reduces single-point failure risk and ensures stable returns.'
  },
  {
    icon: <MapPinned className="h-8 w-8" />,
    title: 'Premium Locations',
    description: 'Strategically placed in high-traffic zones like offices, tech parks, and residential societies.'
  },
  {
    icon: <RefreshCw className="h-8 w-8" />,
    title: 'Daily Consumption Products',
    description: 'Stocking essential food and beverage items ensures consistent repeat demand.'
  },
  {
    icon: <TrendingUp className="h-8 w-8" />,
    title: 'Fully Managed Operations',
    description: 'LIVENEAT handles procurement, maintenance, inventory, and all operational complexities.'
  }
];

const RiskMitigation = () => {
  return (
    <section className="py-24 md:py-32 bg-[#F3F0E6]">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#10B981]">Risk Mitigation</span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#022C22] mt-4 mb-4">
            Built-In Safety Mechanisms
          </h2>
          <p className="text-base leading-relaxed text-[#4B5563] max-w-2xl mx-auto">
            Multiple layers of protection to safeguard your investment
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {riskFactors.map((factor, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white border border-[#E5E7EB] rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 p-8"
            >
              <div className="flex items-start space-x-4">
                <div className="bg-[#D1FAE5] p-4 rounded-2xl text-[#10B981] flex-shrink-0">
                  {factor.icon}
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-[#022C22] mb-2">{factor.title}</h3>
                  <p className="text-base leading-relaxed text-[#4B5563]">{factor.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RiskMitigation;
